import { useQuery, useMutation } from '@tanstack/react-query';
import apiClient from '../../lib/api';
import type { AiChatConversation, AiChatCreateResponse, AiChatMessageResponse, AiChatSummaryResponse, SaijikiEntry } from '../../lib/api';

export const useCreateAiChatConversation = () => {
  return useMutation<AiChatCreateResponse, Error, { topic: 'daily' | 'health' | 'memory'; conversation_starters?: string[] }>({
    mutationFn: (data) => apiClient.createAiChatConversation(data),
  });
};

export const useSendAiChatMessage = () => {
  return useMutation<AiChatMessageResponse, Error, { conversationId: string; content: string }>({
    mutationFn: ({ conversationId, content }) => apiClient.sendAiChatMessage(conversationId, content),
  });
};

export const useAiChatConversation = (conversationId: string | null) => {
  return useQuery<AiChatConversation>({
    queryKey: ['aiChatConversation', conversationId],
    queryFn: async () => {
      if (!conversationId) throw new Error('conversationId is required');
      return await apiClient.getAiChatConversation(conversationId);
    },
    enabled: conversationId !== null && !!apiClient.getIdToken(),
    retry: 1,
  });
};

export const useGenerateAiChatSummary = () => {
  return useMutation<AiChatSummaryResponse, Error, { conversationId: string }>({
    mutationFn: ({ conversationId }) => apiClient.generateAiChatSummary(conversationId),
  });
};

export const useSaijikiToday = () => {
  return useQuery<SaijikiEntry>({
    queryKey: ['saijikiToday'],
    queryFn: () => apiClient.getSaijikiToday(),
    enabled: !!apiClient.getIdToken(),
    staleTime: 60 * 60 * 1000, // 1 hour
    retry: 1,
  });
};
